import ClearRoundedIcon from '@mui/icons-material/ClearRounded'
import { Button, IconButton } from 'ui'

import style from './PropsCardHeader.module.scss'

type PropsCardHeaderProps = {
  title: string
  handleClose: () => void
}

// шаг 2
// выбор параметров для продукта
// -> шапка для карточки продукта
export function PropsCardHeader({ title, handleClose }: PropsCardHeaderProps) {
  return (
    <div className={style.propsCardHeader}>
      <div className='h2'>{title}</div>
      <Button
        variant='text'
        onClick={handleClose}
        startIcon={<ClearRoundedIcon />}
        className={style.closeBtn}
        tabIndex={-1}
        data-testid='param-card-delete-text'
      >
        Удалить
      </Button>
      <IconButton
        className={style.closeIconButton}
        onClick={handleClose}
        tabIndex={-1}
        data-testid='param-card-delete-icon'
      >
        <ClearRoundedIcon />
      </IconButton>
    </div>
  )
}
